import React, { useEffect, useState } from "react";

export default ({ hideRestore }) => {
  const [counter, setCounter] = useState(9);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter((counter) => (counter - 1)), 1000);
    if (!timer) return hideRestore();
    return () => clearInterval(timer);
  }, [counter]);
  
    return (
      <div style={{ fontSize: 8, color: '#347CFF', margin: 'auto' }}>
        {counter !== 0 ? (
          <div>
            {counter}
          </div>
        ) : null}
      </div>
    );
  }